<h1>Error page</h1>

<ion-button [routerLink]="[ '/' ]" routerDirection="root">VOLVER</ion-button>
